import React from 'react';

import { GatsbyRoot } from '@/lib/gatsby';
import { Pricing } from '../subcomponents/checkout/static_pages/Pricing';

export default () => (
  <GatsbyRoot>
    <Pricing />
  </GatsbyRoot>
);
